// extracted by mini-css-extract-plugin
export default {"first-seen-btn":"FirstSeenCol-module__first-seen-btn__HPLSv","firstSeenBtn":"FirstSeenCol-module__first-seen-btn__HPLSv"};